import React, { useState, useEffect } from "react";
import { InputAdornment } from "@mui/material";
import SideMenu from "../../../Components/SideMenu";
import TextField from "@mui/material/TextField";
import Chip from "@mui/material/Chip";

import OutlinedInput from "@mui/material/OutlinedInput";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import InputLabel from "@mui/material/InputLabel";

import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { useGlobalContext } from "../../../../../../context";
import "../../../Dashboard.css";
import Styles from "../../../../../Slices/Mof/Styles.json";
import "../../../Dashboard.css";
import axios from "axios";
import AddIcon from "@mui/icons-material/Add";
import AddBoxIcon from "@mui/icons-material/AddBox";
import AddCircleSharpIcon from "@mui/icons-material/AddCircleSharp";
import RemoveCircleSharpIcon from "@mui/icons-material/RemoveCircleSharp";
// import Chip from "@mui/material/Chip";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import ApiSetting from "../../../../../../Settings/ApiSettings.json";
import Cookies from "universal-cookie";
import { ItemDragging } from "devextreme-react/list";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import swal from 'sweetalert';

// Import css files
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const urlParams = new URLSearchParams(window.location.search);
const myParam = urlParams.get("id");
const cookies = new Cookies();


export default function CommentsOfChecker(props) {
  const AccesPrivilegeAdd=()=>{
    let check=false;
     props?.Access?.map(data=>{
          if(data==2){
            check=true;
          }
     })
  
     return check;
   }
  const AccesPrivilegeView=()=>{
    let check=false;
     props?.Access?.map(data=>{
          if(data==1){
            check=true;
          }
     })
  
     return check;
   }
  
  const AccesPrivilegeEdit=()=>{
    let check=false;
     props?.Access?.map(data=>{
          if(data==3){
            check=true;
          }
     })
  
     return check;
   }
  
  const AccesPrivilegeDelete=()=>{
    let check=false;
     props?.Access?.map(data=>{
          if(data==4){
            check=true;
          }
     })
  
     return check;
  }

  const AccessPrivilegeViewOnly=()=>{
    let check=false;
     props?.Access?.map(data=>{
          if(data==1){
            check=true;
          }
          if(data==2 || data==3){
             check=false;
          }
     })
  
     return check;
  }
  return (
    <div>
           {/* ####===>comments and name of checker name  here...  */}
   
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flexFlow: "row wrap",

        //   border: "1px solid",
          borderColor: "#5f7b8a",
          borderRadius: 10,
          margin: 10,
          paddingBottom: 10,
        }}
      >
        <div
          style={{
            display: "flex",
            width: "50%",
            minWidth: 200,
            marginTop: 10,
            paddingTop: 10,
            paddingLeft: 10,
            paddingRight: 10,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <FormControl fullWidth>
            <TextField
              title={
                props.userRole == 2 ? "" : "فقط المدقق يستطيع ملئ هذا الحقل"
              }
              disabled={AccessPrivilegeViewOnly()}
              label=" اسم المدقق"
              variant="outlined"
              value={props.userRole == 2 ? props.userName : ""}
              inputProps={
                { readOnly: true, }
              }
              onChange={(e) => {
                props.setCheckerName(e.target.value);
                props?.setRenderCheck(!props?.renderCheck)

              }}
            />
          </FormControl>
          <Typography className="fontForError">
            {/* {ErrorMessage.activityTypeError} */}
          </Typography>
        </div>
        <div
          style={{
            display: "flex",
            width: "100%",
            minWidth: 200,
            marginTop: 10,
            paddingTop: 10,
            paddingLeft: 10,
            paddingRight: 10,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <FormControl fullWidth>
            <TextField
              label="الملاحظات "
              title={
                props.userRole == 2 ? "" : "فقط المدقق يستطيع ملئ هذا الحقل"
              }
              disabled={AccessPrivilegeViewOnly()}
              multiline
              minRows={4}
              variant="outlined"
              value={props.checkerNameComments}
              onChange={(e) => {
                props.setCheckerNameComments(e.target.value);
                props?.setRenderCheck(!props?.renderCheck)
              }}
            />
          </FormControl>
          <Typography className="fontForError">
            {/* {ErrorMessage.activityTypeError} */}
          </Typography>
        </div>
      </div>

      {
        AccesPrivilegeEdit()&&props?.ModeOfInsertData=='تحديث'?
        <div
          style={{
            display: "flex",
            marginTop: 10,
            backgroundColor: "#fefefe",
            paddingLeft: 10,
            paddingRight: 10,
            paddingBottom: 30,

            justifyContent: "space-evenly",
            alignItems: "center",
          }}
        >
        

          <Button
            variant="contained"
            style={{
              backgroundColor: "#5f7b8a",
              width: "40%",
              fontSize: "20px",
            }}
            onClick={()=>{
              // if(props?.ModeOfInsertData_tow=="حساب")
              //     props.getCalculationsForAmount(2)
              // else 
              props?.storeDataOfForm(props?.section_id)
              props?.setRenderCheck(!props?.renderCheck)

            }
            }
          >
            {!props.loading ? (
              'تحديث'
            ) : (
              <div className="spinner-border " role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            )}
          </Button>
        </div>
       :null
      }
    </div>
  )
}
